import { render } from "./EtapasMetodoCientifico.vue?vue&type=template&id=3c9d3f6a&scoped=true"
import script from "./EtapasMetodoCientifico.vue?vue&type=script&lang=js"
export * from "./EtapasMetodoCientifico.vue?vue&type=script&lang=js"

import "./EtapasMetodoCientifico.vue?vue&type=style&index=0&id=3c9d3f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9d3f6a"]])

export default __exports__